module.exports = __webpack_public_path__ + "img/logo_sollicita_mural.9c201e69.png";